import type { SvgIconProps } from "./SVGIcon";
import SvgIcon from "./SVGIcon";

export default function IconPhasePreConstruction(props: SvgIconProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6" cy="6" r="6" fill="#FAD264" />
      <path
        d="M6 0C7.05311 1.25583e-08 8.08768 0.277182 8.99973 0.803691C9.91178 1.3302 10.6692 2.08749 11.1958 2.99946C11.7225 3.91142 11.9998 4.94594 12 5.99906C12.0002 7.05217 11.7231 8.08678 11.1968 8.99891C10.6704 9.91105 9.91324 10.6686 9.00136 11.1954C8.08947 11.7222 7.055 11.9997 6.00188 12C4.94877 12.0003 3.91412 11.7235 3.0019 11.1973C2.08969 10.671 1.33204 9.91398 0.805104 9.00217L6 6V0Z"
        fill="#C78A30"
      />
    </SvgIcon>
  );
}
